import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	scheduleLabel: {
		id: 'eoc.escalation-policies.rule-icon.schedule-label.no-translate',
		defaultMessage: 'Schedule',
		description: 'The label of calendar icon for schedule typed rule',
	},
	teamLabel: {
		id: 'eoc.escalation-policies.rule-icon.team-label.no-translate',
		defaultMessage: 'Team',
		description: 'The label of people icon for team typed rule',
	},
	userLabel: {
		id: 'eoc.escalation-policies.rule-icon.user-label.no-translate',
		defaultMessage: 'User',
		description: 'The label of person icon for user typed rule',
	},
});

export default messages;
